import { createSlice } from "@reduxjs/toolkit";
import { getPharmacyCategories } from "../../reducer/getPharmacyCategories/getPharmacyCategoriesReducer";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const getPharmacyCategoriesSlice = createSlice({
  name: "getPharmacyCategories",
  initialState,
  reducers: {
    resetPharmacyCategories: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPharmacyCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPharmacyCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPharmacyCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetPharmacyCategories } = getPharmacyCategoriesSlice.actions;

export default getPharmacyCategoriesSlice.reducer;
